var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      ref: "modal",
      attrs: {
        title: "Preview File",
        "modal-class": "preview-file-modal",
        "body-class": "d-flex justify-content-center",
        "hide-footer": "",
      },
      on: { shown: _vm.ensureAboveSidebars },
    },
    [
      _c("b-spinner", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.loading,
            expression: "loading",
          },
        ],
        attrs: { label: "Loading..." },
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.loading,
              expression: "!loading",
            },
          ],
        },
        [
          _vm.previewType === "image"
            ? _c("img", {
                staticClass: "preview-img",
                attrs: { src: _vm.src },
                on: { load: _vm.onLoad },
              })
            : _vm.previewType === "video"
            ? _c("video", {
                staticClass: "preview-img",
                attrs: { src: _vm.src, controls: "", muted: "" },
                domProps: { muted: true },
                on: { loadeddata: _vm.onLoad },
              })
            : _vm.previewType === "audio"
            ? _c("audio", {
                attrs: { src: _vm.src, controls: "", muted: "" },
                on: { loadeddata: _vm.onLoad },
              })
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }